import { Component, OnInit } from '@angular/core';
import { CATEGORY, SUBCATEGORYTYPE, SUBCATEGORY, IMAGE, PRODUCTDETAILS, CARTVIEW, CARTADD, RELATEDPRODUCT, productComment, productLike, productCommentImageDelete } from 'src/app/config';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ImageService } from 'src/app/image-service/image.service';

@Component({
    selector: 'app-product-details',
    templateUrl: './product-details.component.html',
    styleUrls: ['./product-details.component.css'],
    
})



export class ProductDetailsComponent implements OnInit {
  igst=false;
  tax:any;
  pincode:any;
  pid: string;
  data:any = null;
  assets:any;
  recents: any;
  category: any;
  subcategory: any;
  subsubcategory: any;
  url: any;
  prd_img: any;
  goldquality: any;
  gold: any;
  ade:any;
  pricelist: any;
  pricegold: any;
  diamond: any;
  diamondclarity: any;
  diamondcolour: any;
  defaultdiamond: any;
  pricediamond: any;
  totaldiamond:any;
  totalgold:any;
  finegold: any;
  platinum: any;
  priceplat: any;
  fineplat: any;
  totalplat:any;
  defaultsize: any;
  sizes: any;
  selectedsize: any;
  totalprice: any;
  certificate:any;
  value = 1;
  wish:any;
  cart:any;
  stone: any;
  totalstone:any;
  pricestone: any;
  pricegold2: any;
  gross:any;
  grossWeight:number = 0;
  colvalue: any;
  silver:any;
  pricesilver:any;
  totalsilver:any;
  loader:boolean;
  page:boolean;
  scroll:boolean;
  drop:any;
  loading:boolean;
  likeStatus:boolean = false
  viewdone=0;
  customerInstruction:any;
  slideConfig = {
    "slidesToShow": 1,
    "slidesToScroll": 1,
    "dots": false,
    "infinite": true,
    "autoplay": true,
    "arrows": false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }]
  };
  metalcolour: any;
  discount:any;
  goldlist: any;
  stonelist: any;
  diamondlist: any;
  message: string;
  btn = 1;
  kundan: any;
  manual={'offer':{cgst:0,igst:0,sgst:0,price:0},'withoutoffer':{cgst:0,igst:0,sgst:0,price:0}}
  totalkundan: any;
  pricekund: any;
  black: any;
  priceblack: any;
  totalblack: any;
  pricegram: any;
  totalgram: any;
  gram: any;
  kundanlist: any;
  privious: any;
  defsilver: any;
  defplat: any;
  blacklist: any;
  manufacture: any;
  sizelist: any;
  silverlist: any;
  offer = 0;
  offerPrice = 0;
  platlist: any;
  defaultdiamond2: any;
  discla=[];
  discol=[];
  diamondclarity2: any;
  diamond2: any;
  discla2=[];
  diamondcolour2:any;
  discol2 = [];
  pricediamond2: any;
  totaldiamond2: any;
  diamondlist1: any;
  diamondlist2: any;
  Gramlist: any;
  currentPage:any = 1;
  relatedProductDetail : any = null;
  priceWeight:any;
  recentProducts :any = [];
  comments:any;
  userComment:any;
  selectedFiles: File[] = [];
  imagePreviews: string[] = [];
  base64Image: string = '';
  selectedGoldType:any;
  selectedPlatinumType:any
  selectedSilverType:any
  selectedBeatsType:any
  selectedoneGramType:any
  selectedKundanType:any
  selectedStoneType:any
  totalAmount:any;
  adeList:any;
  priceade:any;
  totalade:any;
  // heartLoader:any = false;
  constructor(public api: ApiService, private route: ActivatedRoute,private router:Router, private imageService: ImageService) {
    this.drop=this.api.drop;
    this.igst = this.api.igst;
    this.route.params.subscribe(params => {
      this.clean();
      this.pid = params.id;
      this.ngOnInit();
      this.getproduct();
      this.getComment();
      this.currentPage=1;
      this.getRelatedProducts();
      });



    this.api.Get(CARTVIEW+"?user_id="+this.api.uid).then(data=>{
        this.cart=data['data'];
    }).catch(d => {
      if( d.status == 503){
        this.api.setGoto();
        this.api.setlogin(0);
        this.api.logout();
        setTimeout(() => {
        },1000);
      } else{
      console.log(d);
      }
    })
    this.total();

   }

   sizechange(value) {
    this.privious = this.selectedsize;
    this.selectedsize = value;
      if (this.gold)  {
        this.getgold(this.gold);
      }
      if (this.platinum)  {
        this.getplatinum(this.platinum);
      }
      if (this.silver) {
        this.getsilver(this.silver);
      }
      this.total();
   }


   quantity(pid)
   {
        let cart=this.api.getCart();
        if(cart)
      {
              let result=cart.find(x => x.product_id == pid);
              if(result)
              {
                    let cartId=result.cart_id;
                    let c=Number(result.count);
                    if(c!=0)  {
                    this.value = c;
                    }
                    return c;
                }
                else{
                  return(0);
                }
        }
   }
    wishlist(pid) {
    if(this.drop==0)
    {
      this.api.setGoto();
      this.api.onSuccess('Please Login First to Continue','Login');
      setTimeout(() => {
          this.router.navigate(['/login']);
          },1000);

    }
    else if(this.drop==1)
   {
      // this.heartLoader=true;
     this.api.checkWishlist(pid);
    //  this.heartLoader = false;
   }
   }


   checkHeart(pid)
  {
    this.wish = this.api.getWishlist();
    if (this.wish) {
            let result = this.wish.find(x => x.product_id === pid);
            if (result)
            {
              return true;

            }
            else
            {
              return false;

            }
      }
      else{
        return false;
      }
  }
   qtyUpdate(pid,value)
   {
        this.api.qtyUpdate(pid,value);
   }
   checkCart(pid)
  {
      let check=this.api.checkCart(pid);
      return check;
  }
  deleteWishlist(pid)
  {
      this.api.deleteWishlist(pid);
  }
  addToCart(s)
  {

    this.message = 'Please wait ...';
    document.getElementById("openModalButton").click();
    this.api.Post(CARTADD, s).then(data=>{
      this.api.updateCart();
      this.api.Cart.emit("cartUpdated"+Date.now());
      document.getElementById("mClose").click();
    this.api.onSuccess('Product Successfully added to the cart','Product Added');
    //  localStorage.setItem('cart',JSON.stringify(data));
    }).catch(d=>{
      if( d.status == 503){
        this.api.onFail('Your session is expired please login again','Login');
        this.api.setGoto();
        this.api.setlogin(0);
        this.api.logout();
        document.getElementById("mClose").click();
        setTimeout(() => {
        this.router.navigate(['/login']);
        },1000);
        if( d.status == 401){
          document.getElementById("mClose").click();
          this.api.onFail('Product is already in the cart','Add Product');
        }
      }else if( d.status == 401){
        document.getElementById("mClose").click();
        this.api.onFail('Product is already in the cart','Add Product');
      }
       else{
      this.api.Cart.emit("cartUpdated"+Date.now());
      }
    });
    this.message = null;
  }

  manualoffer(){
    
    if(this.data && this.data.price_type == "Manually"){
      if(this.data.offer_type){
        if(this.data.offer_type == 'Flat'){
          this.offer = this.data.amount - this.data.offer_amount;
        }else if(this.data.offer_type == 'Percentage'){
          this.offer = Number(this.data.amount) - Number(this.data.amount)*0.01*Number(this.data.offer_amount);
        }
        if(this.igst) {
          
          if(this.offer==0){
            this.tax = Number(this.data.amount) * 0.01 * Number(this.data.IGST);
          } else{
            this.tax = Number(this.offer) * 0.01 * Number(this.data.IGST);
            this.offer = Number(this.offer)+Number(this.offer) * 0.01 * Number(this.data.IGST);
          }
          this.totalprice = Number(this.data.amount) + Number(this.tax);
        } else {
          
          if(this.offer==0){
            this.tax = Number(this.data.amount) * 0.01 * Number(this.data.SGST)+Number(this.data.amount) *0.01 * Number(this.data.CGST);
          } else{
            this.tax = Number(this.offer)* 0.01 * Number(this.data.SGST)+Number(this.offer) *0.01 * Number(this.data.CGST);
            this.offer = Number(this.offer) + Number(this.offer)* 0.01 * Number(this.data.SGST)+Number(this.offer) *0.01 * Number(this.data.CGST);
          }
          this.totalprice = Number(this.data.amount) + Number(this.tax);
        }
      }else{
        if(this.igst) {
          
          if(this.offer==0){
            this.tax = Number(this.data.amount) * 0.01 * Number(this.data.IGST);

          } else{
            this.tax = Number(this.offer) * 0.01 * Number(this.data.IGST);
            this.offer = Number(this.offer)+Number(this.offer) * 0.01 * Number(this.data.IGST);
          }
          this.totalprice = Number(this.data.amount)+Number(this.data.amount) * 0.01 * Number(this.data.IGST) + Number(this.tax);
        } else {
          if(this.offer==0){
            this.tax = Number(this.data.amount) * 0.01 * Number(this.data.SGST)+Number(this.data.amount) *0.01 * Number(this.data.CGST);
          } else{
            this.tax = Number(this.offer)* 0.01 * Number(this.data.SGST)+Number(this.offer) *0.01 * Number(this.data.CGST);
            this.offer = Number(this.offer) + Number(this.offer)* 0.01 * Number(this.data.SGST)+Number(this.offer) *0.01 * Number(this.data.CGST);
          }
          this.totalprice = Number(this.data.amount)+Number(this.data.amount * 0.01 * this.data.SGST)+Number(this.data.amount *0.01 * this.data.CGST) + Number(this.tax);
      }
    }

    }
  }

  go(value) {
    this.api.godetail(value);
  }

  getRelatedProducts()
  {
      this.api.Get(RELATEDPRODUCT+'?productid='+this.pid + '&page=' + this.currentPage).then((data:any)=>{
        for(let i = 0 ; i < data?.recent_product?.length ; i++)
        {
          this.recentProducts.push(data.recent_product[i]);
        }
        this.relatedProductDetail = data;
        if(this.recentProducts && this.pricelist)
        {
          this.priceWeight = this.api.calculateFilter(this.recentProducts,this.pricelist,this.api.igst);
        }
      })
  }

  pageChanged()
  {
      this.currentPage = Number(this.currentPage) + 1;
      this.getRelatedProducts();
  }

  getComment(){
    this.api.GetWithId(productComment,  this.pid).then(data => {
      this.comments = data
      this.userComment = this.comments?.my_comment?.comment
      let image = []
      if(this.comments?.my_comment?.images){
        this.comments?.my_comment?.images?.split(',').forEach((el)=>{
            image.push(this.comments?.url + el)
        })
        this.imagePreviews = image;
      }
     
    })
  }

  changetoBase64(url){
    const imageUrl = 'https://gourigold.in/app/public/img/product/1749104315_0.webp'; // Example image

    this.imageService.convertImageUrlToBase64(imageUrl)
      .then(base64 => {
        this.base64Image = base64;
      })
      .catch(err => {
        console.error('Failed to convert:', err);
      });
  }


  submitComment(){
    const formData = new FormData();
    formData.append('product_id', this.pid)
    formData.append('comment', this.userComment)
    this.selectedFiles.forEach((file, index) => {
      formData.append('images[]', file);
    });
    let apiUrl = productComment+"/store"
    this.api.Post(apiUrl, formData).then(data  => {
      this.api.onSuccess(data["message"],'');
      this.getComment()
    })
  }

  deleteComment(commentId:any){
    let apiUrl = productComment+"/delete/"+commentId
    this.api.Get(apiUrl).then(data  => {
      this.userComment = ""
      this.api.onSuccess(data["message"],'');
      this.getComment()
    })
  }

  deleteUserImage(id:any){
    let obj = {
      comment_id:this.comments?.my_comment?.id,
      image_index: id
    }
    this.api.Post(productCommentImageDelete, obj).then(data  => {
      this.userComment = ""
      this.api.onSuccess(data["message"],'');
      this.getComment()
    })
  }

  likeProduct(){
    let obj = {
      product_id:this.pid
    }
    this.api.Post(productLike, obj).then(data  => {
      this.api.onSuccess(data["message"],'');
      this.likeStatus = !this.likeStatus
      if(this.likeStatus){
        this.data.like_count = this.data?.like_count + 1
      }else{
        this.data.like_count = this.data?.like_count - 1
      }
    })
  }

  openAccordian(asset:any){
    this.assets.forEach((el:any)=>{
      el.show = !el.show
    })
  }

   getproduct() {
     this.loader=true;
     this.page=false;
     this.api.Put3(PRODUCTDETAILS, this.pid ).then(data  => {
        this.page=true;
        this.loader=false;
        this.likeStatus = data['like_status'] == 1 ? true : false
        if(data['data'])  {
            this.data = data['data'];
            this.pricelist = data['price'];
              this.assets = data['assets'];
              this.assets.forEach((el:any)=>{
                el.show = false,
                this.grossWeight += Number(el?.weight)
              })
            if(this.data.jwellery_type){
              this.data.jwellery_type = this.data.jwellery_type.toUpperCase();

              if(this.data.jwellery_type == 'BANGLES & KADA BRACELET')
              {
                this.sizelist = this.pricelist.bangle;
              }
              if(!this.data.CGST){
                this.data.CGST = 0;
              }
              if(!this.data.IGST){
                this.data.IGST = 0;
              }
              if(!this.data.SGST){
                this.data.SGST = 0;
              }
            }



        }
        if(this.data.color)
        {
          this.metalcolour = this.data.color.split(',');
          this.colvalue = this.metalcolour[0];
        }
        this.prd_img =data['files'];
        this.certificate = data['Certification'];
        this.recents = data['recent_product'];
        this.url =IMAGE;
        this.manufacture = data['manufacture'];
        this.manualoffer();
        if (this.data.size_type && this.data.size_type != 'None' ) {
          this.defaultsize = this.data.default_size;
          this.sizes = this.data.size_type.split(',');
          this.selectedsize = this.defaultsize;
          let temp = [];
          if(this.sizelist){
          this.sizes.forEach(childObj => {

             let s = this.sizelist.find(x => x.sizes == childObj);

            temp.push(s);
          });
          this.sizelist = temp;
        }
        }
        setTimeout(() => {
          this.viewdone =1;
          if (this.assets) {
            this.goldlist = this.assets.filter(x => x.metrial_type == "Gold");
            if( this.goldlist.length ){ this.getgold(this.goldlist[0])};

            this.stonelist = this.assets.filter(x => x.metrial_type == "STONE");
          if( this.stonelist.length ){ this.getstone(this.stonelist[0])};

          this.diamondlist = this.assets.filter(x => x.metrial_type == "Diamond");
          if(this.diamondlist){this.diamondpriceNew()}
      //     this.diamondlist1 = this.diamondlist.filter(x => x.diamond_index == 1);
      //     this.diamondlist2 = this.diamondlist.filter(x => x.diamond_index == 2);
      //     if(this.diamondlist1.length >= 1 && this.diamondlist2.length == 0 ){
      //       this.diamond = this.diamondlist1[0];
      //      this.diamondcolour = this.diamond.color.split(',');
      //     this.diamondclarity = this.diamond.clarity.split(',');
      //     this.defaultdiamond = this.diamond.default_color_clarity.split('/');
      //     this.diamondprice();
      //   } else if(this.diamondlist1.length >= 1 && this.diamondlist2.length > 0 ){
      //     this.diamond = this.diamondlist1[0];
      //     this.diamondcolour = this.diamond.color.split(',');
      //    this.diamondclarity = this.diamond.clarity.split(',');
      //    this.defaultdiamond = this.diamond.default_color_clarity.split('/');
      //    this.diamondprice();
      //   this.diamond2 = this.diamondlist2[0];
      //   this.diamondcolour2 = this.diamond2.color.split(',');
      //   this.diamondclarity2 = this.diamond2.clarity.split(',');
      //   this.diamondcolour2.forEach(element => {
      //     this.discol2.push(0);
      //   });
      //   this.diamondclarity2.forEach(element => {
      //   this.discla2.push(0);
      //   });
      //   this.defaultdiamond2 = this.diamond2.default_color_clarity.split('/');
      //   this.diamondprice(2);
      // }else if(this.diamondlist2.length >= 1){
      //     this.diamond2 = this.diamondlist2[0];
      //     this.diamondcolour2 = this.diamond2.color.split(',');
      //     this.diamondclarity2 = this.diamond2.clarity.split(',');
      //     this.diamondcolour2.forEach(element => {
      //       this.discol2.push(0);
      //     });
      //     this.diamondclarity2.forEach(element => {
      //     this.discla2.push(0);
      //     });
      //     this.defaultdiamond2 = this.diamond2.default_color_clarity.split('/');
      //     this.diamondprice(2);
      // }


          this.kundanlist = this.assets.filter(x => x.metrial_type == "Kudan");
          if(this.kundanlist.length){ this.getkundan(this.kundanlist[0])};
          this.blacklist = this.assets.filter(x => x.metrial_type == "BEATS");
         if(this.blacklist.length){ this.getblackbit(this.blacklist[0])};
         this.Gramlist = this.assets.filter(x => x.metrial_type == "1 Gram");
         if(this.Gramlist.length){ this.getgram(this.Gramlist[0])};
         // this.getgram();
          
          this.adeList = this.assets.filter(x => x.metrial_type == "ADE");
           if(this.adeList.length){ this.getAde()};

           this.platlist = this.assets.filter(x => x.metrial_type == "Platinum");
          this.defplat = Object.assign({},this.platinum)
          if(this.platlist.length){
            this.getplatinum(this.platlist[0]);}

            this.silverlist = this.assets.filter(x => x.metrial_type == "Silver");
         if(this.silverlist.length){
          this.getsilver(this.silverlist[0]);}
        }
          },4000);

        this.api.Post(SUBCATEGORY, {category_id: this.data['category_id']} ).then(data  => {

              let result = data['data'].find(x => x.id == this.data['subcategory_id']);
              this.subcategory = result['subcategory'];
              this.api.Post(SUBCATEGORYTYPE, {subcategory_id: this.data['subcategory_id']} ).then(data  => {
                  let result = data['data'].find(x => x.id == this.data['subsubcategory_id']);
                  this.subsubcategory = result['title'];
              }).catch(d=>{console.log(d);});
       }).catch(d=>{console.log(d);});
    }).catch(d=>{console.log(d);});



    this.api.Post(CATEGORY, {} ).then(data  => {
     let result = data['data'].find(x => x.id == this.data?.category_id);
     this.category = result?.category;
  }).catch(d=>{console.log(d);});
}

   createjson() {
     this.loading=true;
     this.drop=this.api.drop;
    if(this.drop==0)
    {
      this.api.setGoto();
      this.api.onSuccess('Please Login First to Continue','Login');
      setTimeout(() => {
          this.router.navigate(['/login']);
          },1000);
    }
    else if(this.drop==1)
   {
    let j = {};
    let temparray = [];
    if(this.data.price_type != 'Manually')
  {
    if (this.gold) {
        j['option'] = this.gold.charges_option;
        j['weight'] = this.gold.weight;
        j['wastage'] = this.gold.wastage;
        j['color'] = this.gold.color;
        j['quantity'] = this.gold.quantity;
       // j['product_size'] = this.selectedsize;
        j['materialType'] = this.pricegold.type;
        j['productId'] = this.pid;
        j['metal'] = 'Gold';
        j['makingCharge'] = this.gold.making_charge;
        temparray.push(j);
        j = {};
      }
      if (this.diamond) {
        j['crtcost_option'] = this.diamond.crtcost_option;
          j['certification_cost'] = this.diamond.certification_cost;
        j['option'] = this.diamond.charges_option;
        j['weight'] = this.diamond.weight;
        j['wastage'] = this.diamond.wastage;
        j['diamondType'] = this.diamond.jwellery_size;
        j['diamond_index'] = '1';
          //j['product_size'] = this.selectedsize;
        j['materialType'] = this.defaultdiamond[0] + '/' + this.defaultdiamond[1];
        j['productId'] = this.pid;
        j['metal'] = 'Diamond';
        j['makingCharge'] = this.diamond.making_charge;
        temparray.push(j);
        j = {};
      }
      if (this.diamond2) {
        j['crtcost_option'] = this.diamond2.crtcost_option;
        j['certification_cost'] = this.diamond2.certification_cost;
        j['option'] = this.diamond2.charges_option;
        j['weight'] = this.diamond2.weight;
        j['wastage'] = this.diamond2.wastage;
        j['diamondType'] = this.diamond2.jwellery_size;
        j['diamond_index'] = '2';
          //j['product_size'] = this.selectedsize;
        j['materialType'] = this.defaultdiamond2[0] + '/' + this.defaultdiamond2[1];
        j['productId'] = this.pid;
        j['metal'] = 'Diamond';
        j['makingCharge'] = this.diamond2.making_charge;
        temparray.push(j);
        j = {};
      }
    if (this.platinum!=null) {
      j['option'] = this.platinum.charges_option;
      j['weight'] = this.platinum.weight;
      j['materialType'] = this.platinum.jwellery_size;
      j['wastage'] = this.platinum.wastage;
      j['color'] = this.platinum.color;
      j['quantity'] = this.platinum.quantity;
    //    j['product_size'] = this.selectedsize;
      j['productId'] = this.pid;
      j['metal'] = 'Platinum';
      j['makingCharge'] = this.platinum.making_charge;
      temparray.push(j);
      j = {};
    }
    if (this.stone) {
      j['option'] = this.stone.charges_option;
      j['weight'] = this.stone.weight;
      j['materialType'] = this.stone.jwellery_size;
      j['productId'] = this.pid;
      j['metal'] = 'STONE';
      j['color'] = this.stone.color;
      j['quantity'] = this.stone.quantity;
      j['wastage'] = this.stone.wastage;
     //   j['product_size'] = this.selectedsize;
      j['makingCharge'] = this.stone.making_charge;
      temparray.push(j);
      j = {};
    }

    if (this.silver!=null) {
      j['option'] = this.silver.charges_option;
      j['weight'] = this.silver.weight;
      j['materialType'] = this.silver.jwellery_size;
      j['productId'] = this.pid;
      j['color'] = this.silver.color;
      j['quantity'] = this.silver.quantity;
      j['wastage'] = this.silver.wastage;
   //  j['product_size'] = this.selectedsize;
      j['metal'] = 'Silver';
      j['makingCharge'] = this.silver.making_charge;
      temparray.push(j);
      j = {};
    }

    if (this.black!=null) {
      j['option'] = this.black.charges_option;
      j['weight'] = this.black.weight;
      j['materialType'] = this.priceblack.type;
      j['productId'] = this.pid;
      j['color'] = this.black.color;
      j['quantity'] = this.black.quantity;
      j['wastage'] = this.black.wastage;
    //  j['product_size'] = this.selectedsize;
      j['metal'] = 'BEATS';
      j['makingCharge'] = this.black.making_charge;
      temparray.push(j);
      j = {};
    }

    if (this.gram!=null) {
      j['option'] = this.gram.charges_option;
      j['weight'] = this.gram.weight;
      j['materialType'] = this.pricegram.type;
      j['productId'] = this.pid;
      j['color'] = this.gram.color;
      j['quantity'] = this.gram.quantity;
      j['wastage'] = this.gram.wastage;
    //  j['product_size'] = this.selectedsize;
      j['metal'] = '1 Gram';
      j['makingCharge'] = this.gram.making_charge;
      temparray.push(j);
      j = {};
    }

    if (this.kundan!=null) {
      j['option'] = this.kundan.charges_option;
      j['weight'] = this.kundan.weight;
      j['materialType'] = this.pricekund.type;
      j['productId'] = this.pid;
      j['wastage'] = this.kundan.wastage;
      j['color'] = this.kundan.color;
      j['quantity'] = this.kundan.quantity;
    //  j['product_size'] = this.selectedsize;
      j['metal'] = 'Kudan';
      j['makingCharge'] = this.kundan.making_charge;
      temparray.push(j);
      j = {};
    }
  }
    let uid = this.api.getUserInfo();
    uid = uid.id;
   if(this.data.price_type != 'Manually'){ j['assests'] = temparray};
    if(this.data.price_type == 'Manually'){ j['assests'] = {}};
  //  j['category'] = this.data['category_id'];
    j['count'] = this.value;
    j['jwellery_type'] = this.data.jwellery_type;
    j['selectedColor'] = this.colvalue;
    if(this.data.price_type != 'Manually' && (this.data.jwellery_type == 'RING' || this.data.jwellery_type == 'BANGLES & KADA BRACELET' || this.data.jwellery_type == 'CHAIN & ITEM INCHS')){
       if(this.data.jwellery_type == 'BANGLES & KADA BRACELET'){
         let si = this.sizelist.find(x => x.sizes == this.selectedsize);
          j['product_size'] = si.bangle_size;

       }else{
       j['product_size'] = this.selectedsize;
      }
      }
    else { j['product_size'] = 0};
    this.data.CGST ? j['CGST'] = this.data.CGST :j['CGST'] = 0;
    this.data.SGST ? j['CGST'] = this.data.SGST :j['SGST'] = 0;
    this.data.IGST ? j['CGST'] = this.data.SGST :j['SGST'] = 0;
    j['offer_type'] = this.data.offer_type;
    j['offer_amount'] = this.data.offer_amount;
    j['instate'] = this.igst;
    j['description'] = this.data.description;
    j['productCode'] = this.data.productcode;
    j['productId'] = Number(this.pid);
    j['productName'] = this.data.productname;
    j['productType'] = this.data.jwellery_type;
  //  j['subCategory'] = this.data['subcategory_id'];
  //  j['subSubCategory'] = this.data['subsubcategory_id'];
    j['userid'] = (uid).toString();
    temparray = [];
    temparray.push(j);
    j = {};
    j['data'] = temparray;
    j['customer_instruction'] = this.customerInstruction || '';
    this.addToCart(j);
    let check=this.checkCart(this.pid);
    if(check==true)
    {
      this.loading=false;
    }
    else if(check==false)
    {
      this.loading=false;
    }
   }

   }

  colormetal(value) {
    this.colvalue = value;
  }
   getstone(value)  {
      this.stone = value;
      this.selectedStoneType = value?.jwellery_size;
      let name = this.stone.jwellery_size;
      this.pricestone = this.pricelist.STONE.find(x => x.type == name);
      if(this.pricestone){
      this.totalstone = this.api.price(this.stone.weight,this.pricestone.price,this.stone.charges_option,this.stone.making_charge,0,0,this.stone.quantity);
      this.totalstone = Math.round(this.totalstone.price);
      this.total();
      this.grossweight();
      this.button();
    } else{
        this.button();
      }
   }

   getgold(value) {
    this.selectedGoldType = value?.jwellery_size;
    this.gold = Object.assign({},this.goldlist.find(x => x.jwellery_size == value.jwellery_size));
    if (this.sizes && this.privious != this.selectedsize && (this.data.jwellery_type == 'RING' || this.data.jwellery_type == 'BANGLES & KADA BRACELET' ||  this.data.jwellery_type == 'CHAIN & ITEM INCHS')) {
      let increament = this.selectedsize - this.defaultsize;
      increament = increament * 0.2;
      this.gold.weight = (Number(this.gold.weight) + increament).toFixed(2);

      // if(this.data.gender == 'FeMale'){
      //   if(this.selectedsize >= 6 && this.selectedsize <= 10){
      //     this.gold.weight = (Number(this.gold.weight)*0.95).toFixed(2);
      //   } else if(this.selectedsize >= 15 && this.selectedsize <= 18){
      //     this.gold.weight = (Number(this.gold.weight)*1.07).toFixed(2);
      //   } else if(this.selectedsize >= 19 && this.selectedsize <= 22){
      //     this.gold.weight = (Number(this.gold.weight)*1.1).toFixed(2);
      //   }
      // }else if(this.data.gender == 'Male'){
      //   if(this.selectedsize >= 14 && this.selectedsize <= 17){
      //     this.gold.weight = (Number(this.gold.weight)*0.95).toFixed(2);
      //   } else if(this.selectedsize >= 22 && this.selectedsize <= 25){
      //     this.gold.weight = (Number(this.gold.weight)*1.08).toFixed(2);
      //   } else if(this.selectedsize >= 26 && this.selectedsize <= 30){
      //     this.gold.weight = (Number(this.gold.weight)*1.12).toFixed(2);
      //   }  else if(this.selectedsize >= 31 && this.selectedsize <= 34){
      //     this.gold.weight = (Number(this.gold.weight)*1.15).toFixed(2);
      //   } }
    }
  //   else if (this.sizes && this.privious != this.selectedsize && this.data.jwellery_type == 'BANGLES & KADA BRACELET') {
  //    let a = 1;
  //    let increament = this.selectedsize - this.defaultsize;
  //    if(increament > 0){
  //    for(let i = 0;i < increament;i++){
  //      a += a*0.05;
  //    }
  //   }else if(increament < 0){
  //     for(let i = 0;i > increament;i--){
  //       a -= a*0.05;
  //     }
  //    }
  //   //  increament = increament * 0.2;
  //    this.gold.weight = (Number(this.gold.weight) * a).toFixed(3);
  //  } else if (this.sizes && this.privious != this.selectedsize && this.data.jwellery_type == 'CHAIN & ITEM INCHS') {

  //    let increament = this.selectedsize - this.defaultsize;
  //    increament = (Number(this.gold.weight)/Number(this.defaultsize)) * increament;
  //    this.gold.weight = (Number(this.gold.weight) + increament).toFixed(3);
  //  }
     this.pricegold = this.pricelist.Gold.find(x => x.type == this.gold.jwellery_size);
    if(this.pricegold) {
     this.pricegold2 = this.pricelist.Gold.find(x => x.type == '24KT');
     if (this.gold.charges_option == "PerGram" || this.gold.charges_option == "Fixed" ) {
      this.totalgold = this.api.price(this.gold.weight,this.pricegold.price,this.gold.charges_option,this.gold.making_charge);
      this.finegold = Number(this.totalgold.weight).toFixed(3);
      this.totalgold = Math.round(this.totalgold.price);
     }  else if (this.gold.charges_option == "Percentage") {
      this.totalgold = this.api.price(this.gold.weight,this.pricegold2.price,this.gold.charges_option,this.gold.making_charge,0,this.pricegold.value_in);
      this.finegold = Number(this.totalgold.weight).toFixed(3);
      this.totalgold = Math.round(this.totalgold.price);
    }
     this.total();
     this.grossweight();
     this.button();
    } else{
       this.button();
     }
   }

   button(){
     if(this.viewdone==1){
    if (this.gold && !this.pricegold) {
      this.btn = 0;
      document.getElementById("openModalButton2").click();
       this.message = 'Please Choose Another option in gold in this product \n as it is not available with current gold selection';
    }
  else  if (this.platinum && !this.priceplat) {
    this.btn = 0;

    document.getElementById("openModalButton2").click();
    this.message = 'Please Choose Another option in platinum in this product \n as it is not available with current platinum selection';
    }
  else  if (this.diamond && !this.pricediamond) {
    this.btn = 0;

    document.getElementById("openModalButton2").click();
    this.message = 'Please Choose Another option in diamond in this product \n as it is not available with current diamond selection';
    }
 else   if (this.stone && !this.pricestone) {
  this.btn = 0;

  document.getElementById("openModalButton2").click();
  this.message = 'Please Choose Another option in stone in this product \n as it is not available with current stone selection';
    }
   else if (this.silver && !this.pricesilver) {
    this.btn = 0;

    document.getElementById("openModalButton2").click();
    this.message = 'Please Choose Another option in silver in this product \n as it is not available with current silver selection';
    } else if (this.kundan && !this.pricekund) {
      this.btn = 0;

      document.getElementById("openModalButton2").click();
      this.message = 'Please Choose Another option in Kundan in this product \n as it is not available with current Kundan selection';
      }else if (this.gram && !this.pricegram) {
        this.btn = 0;

        document.getElementById("openModalButton2").click();
        this.message = 'Please Choose Another option in 1GRAM in this product \n as it is not available with current 1GRAM selection';
        }else if (this.black && !this.priceblack) {
          this.btn = 0;

          document.getElementById("openModalButton2").click();
          this.message = 'Please Choose Another option in Blackbit in this product \n as it is not available with current Blackbit selection';
          }else{
      this.btn = 1;
    }}
   }
   getplatinum(value) {
    this.selectedPlatinumType = value?.jwellery_size;
    this.platinum = Object.assign({},this.platlist.find(x => x.jwellery_size == value.jwellery_size));
   // this.platinum = Object.assign({},this.defplat);
   if(this.platinum)
    {
      if (this.sizes && this.privious != this.selectedsize && (this.data.jwellery_type == 'RING' || this.data.jwellery_type == 'BANGLES & KADA BRACELET' ||  this.data.jwellery_type == 'CHAIN & ITEM INCHS')) {


        let increament = this.selectedsize - this.defaultsize;
        increament = increament * 0.2;
        this.platinum.weight = (Number(this.platinum.weight) + increament).toFixed(2);


        // if(this.data.gender == 'FeMale'){
        //   if(this.selectedsize >= 6 && this.selectedsize <= 10){
        //     this.platinum.weight = (Number(this.platinum.weight)*0.95).toFixed(2);
        //   } else if(this.selectedsize >= 15 && this.selectedsize <= 18){
        //     this.platinum.weight = (Number(this.platinum.weight)*1.07).toFixed(2);
        //   } else if(this.selectedsize >= 19 && this.selectedsize <= 22){
        //     this.platinum.weight = (Number(this.platinum.weight)*1.1).toFixed(2);
        //   }
        // }else if(this.data.gender == 'Male'){
        //   if(this.selectedsize >= 14 && this.selectedsize <= 17){
        //     this.platinum.weight = (Number(this.platinum.weight)*0.95).toFixed(2);
        //   } else if(this.selectedsize >= 22 && this.selectedsize <= 25){
        //     this.platinum.weight = (Number(this.platinum.weight)*1.08).toFixed(2);
        //   } else if(this.selectedsize >= 26 && this.selectedsize <= 30){
        //     this.platinum.weight = (Number(this.platinum.weight)*1.12).toFixed(2);
        //   }  else if(this.selectedsize >= 31 && this.selectedsize <= 34){
        //     this.platinum.weight = (Number(this.platinum.weight)*1.15).toFixed(2);
        //   }
        // }
    // } else if (this.sizes && this.privious != this.selectedsize && this.data.jwellery_type == 'BANGLES & KADA BRACELET') {

    //   let a = 1;
    //  let increament = this.selectedsize - this.defaultsize;
    //  if(increament > 0){
    //  for(let i = 0;i < increament;i++){
    //    a += a*0.05;
    //  }
    // }else if(increament < 0){
    //   for(let i = 0;i > increament;i--){
    //     a -= a*0.05;
    //   }
    //  }
    //   this.platinum.weight = (Number(this.platinum.weight)*a).toFixed(2);
    // } else if (this.sizes && this.privious != this.selectedsize && this.data.jwellery_type == 'CHAIN & ITEM INCHS') {

    //   let increament = this.selectedsize - this.defaultsize;
    //   increament = (Number(this.platinum.weight)/Number(this.defaultsize)) * increament;
    //   this.platinum.weight = (Number(this.platinum.weight) + increament).toFixed(2);
     }
    this.priceplat = this.pricelist.Platinum.find(x => x.type == this.platinum.jwellery_size);
      if(this.priceplat){
    this.totalplat = this.api.price(this.platinum.weight,this.priceplat.price,this.platinum.charges_option,this.platinum.making_charge,0);
    this.totalplat = Math.round(this.totalplat.price);
    this.total();
    this.grossweight();
    this.button();
  } else{
      this.button();
    }
  }
  }

  getsilver(value) {
    this.selectedSilverType = value?.jwellery_size;
    this.silver = Object.assign({},value);
    if (this.silver)
     {
       if (this.sizes && this.privious != this.selectedsize && (this.data.jwellery_type == 'RING' || this.data.jwellery_type == 'BANGLES & KADA BRACELET' ||  this.data.jwellery_type == 'CHAIN & ITEM INCHS')) {

        let increament = this.selectedsize - this.defaultsize;
      increament = increament * 0.2;
      this.silver.weight = (Number(this.silver.weight) + increament).toFixed(2);

        // if(this.data.gender == 'FeMale'){
        //   if(this.selectedsize >= 6 && this.selectedsize <= 10){
        //     this.silver.weight = (Number(this.silver.weight)*0.95).toFixed(2);
        //   } else if(this.selectedsize >= 15 && this.selectedsize <= 18){
        //     this.silver.weight = (Number(this.silver.weight)*1.07).toFixed(2);
        //   } else if(this.selectedsize >= 19 && this.selectedsize <= 22){
        //     this.silver.weight = (Number(this.silver.weight)*1.1).toFixed(2);
        //   }
        // }else if(this.data.gender == 'Male'){
        //   if(this.selectedsize >= 14 && this.selectedsize <= 17){
        //     this.silver.weight = (Number(this.silver.weight)*0.95).toFixed(2);
        //   } else if(this.selectedsize >= 22 && this.selectedsize <= 25){
        //     this.silver.weight = (Number(this.silver.weight)*1.08).toFixed(2);
        //   } else if(this.selectedsize >= 26 && this.selectedsize <= 30){
        //     this.silver.weight = (Number(this.silver.weight)*1.12).toFixed(2);
        //   }  else if(this.selectedsize >= 31 && this.selectedsize <= 34){
        //     this.silver.weight = (Number(this.silver.weight)*1.15).toFixed(2);
        //   }
         }
    // } else if (this.sizes && this.privious != this.selectedsize &&  this.data.jwellery_type == 'BANGLES & KADA BRACELET') {

    //   let a = 1;
    //  let increament = this.selectedsize - this.defaultsize;
    //  if(increament > 0){
    //  for(let i = 0;i < increament;i++){
    //    a += a*0.05;
    //  }
    // }else if(increament < 0){
    //   for(let i = 0;i > increament;i--){
    //     a -= a*0.05;
    //   }
    //  }

    //   this.silver.weight = (Number(this.silver.weight) * a).toFixed(2);
    // }else if (this.sizes && this.privious != this.selectedsize  && this.data.jwellery_type == 'CHAIN & ITEM INCHS') {

    //   let increament = this.selectedsize - this.defaultsize;
    //   increament = (Number(this.silver.weight)/Number(this.defaultsize)) * increament;
    //   this.silver.weight = (Number(this.silver.weight) + increament).toFixed(2);
    // }
    this.pricesilver = this.pricelist.Silver.find(x => x.type == this.silver.jwellery_size);
     if(this.pricesilver) {
    this.totalsilver = this.api.price(this.silver.weight,this.pricesilver.price,this.silver.charges_option,this.silver.making_charge,this.silver.wastage);
    this.totalsilver = Math.round(this.totalsilver.price);
    this.total();
    this.grossweight();
    this.button();
  } else{
      this.button();
    }
  }
  }


  getkundan(value){
    this.kundan = value;
    this.selectedKundanType = value?.jwellery_size;
   if(this.kundan)
    {
    this.pricekund = this.pricelist.Kudan.find(x => x.type == this.kundan.jwellery_size);
    if(this.pricekund){
    this.totalkundan = this.api.price(this.kundan.weight,this.pricekund.price
  ,this.kundan.charges_option,this.kundan.making_charge,
      this.kundan.wastage,0,this.kundan.quantity);
    this.totalkundan = Math.round(this.totalkundan.price);
    this.total();
    this.grossweight();
    this.button();
  } else{
      this.button();
    }
  }
  }

  getgram(value){
    this.gram = value;
    this.selectedoneGramType = value?.jwellery_size;
   if(this.gram)
    {
   this.pricegram = this.pricelist['1 Gram'].find(x => x.type == this.gram.jwellery_size);
    if(this.pricegram){
    this.totalgram = this.api.price(this.gram.weight,this.pricegram.price
      ,this.gram.charges_option,this.gram.making_charge,
      this.gram.wastage,0,this.gram.quantity);
    this.totalgram = Math.round(this.totalgram.price);
    this.total();
    this.grossweight();
    this.button();
  } else{
      this.button();
    }
  }
  }

  getAde(){
    console.log("adeList", this.adeList);
   if(this.adeList){
    this.adeList.forEach(element => {
      this.priceade = this.pricelist.ADE.find(x => x.type == element.jwellery_size);
      if(this.priceade){
        let adePrice = this.api.price(element.weight,this.priceade.price, element.charges_option,element.making_charge, element.wastage,0,element.quantity);
        console.log("adePrice", adePrice.price);
        this.totalade += Math.round(adePrice.price);
        console.log("adePrice", this.totalade);
        this.total();
        this.grossweight();
        this.button();
      } else{
          this.button();
      }
    })
    }
  }
  
  diamondpriceNew(){
   if(this.diamondlist){
      this.diamondlist.forEach(element => {
        this.pricediamond = this.pricelist.Diamond.filter(x => x.diamond_type == element?.jwellery_size);
        this.pricediamond = this.pricediamond.find(x => x.type == element?.default_color_clarity);
        if (this.pricediamond)
        {
          let diamondprice = this.api.price(element.weight,this.pricediamond.price,element.charges_option,element.making_charge,0,0,element.quantity);
          this.totaldiamond +=  Math.round(diamondprice.price);
          this.total();
          this.grossweight();
          this.button();
        } else{
            this.button();
        }
      })
  }
  }

  getblackbit(value){
    this.black = value;
    this.selectedBeatsType = value?.jwellery_size;
   if(this.black)
    {
    this.priceblack = this.pricelist.BEATS.find(x => x.type == this.black.jwellery_size);
    if(this.priceblack){
    this.totalblack = this.api.price(this.black.weight,this.priceblack.price
      ,this.black.charges_option,this.black.making_charge,
      this.black.wastage,0,this.black.quantity);
    this.totalblack = Math.round(this.totalblack.price);
    this.total();
    this.grossweight();
    this.button();
  } else{
      this.button();
    }
  }
  }

//   colorClarity(value0, value1,type=1) {
//     if(type==1){


//     if(value0 != 0)
//     {
//      this.defaultdiamond[0] = value0;
//      this.diamondprice();
//    }else if(value1 != 0){
//      this.defaultdiamond[1] = value1;
//      this.diamondprice();
//    }

//    }else if(type=2){
//      if(value0 != 0)
//     {
//      this.defaultdiamond2[0] = value0;
//      this.diamondprice(2);
//    }else if(value1 != 0){
//      this.defaultdiamond2[1] = value1;
//      this.diamondprice(2);
//    }
//    }
//  }

//  diamondprice(type=1)  {
//   if(type==1){

//    let name = this.defaultdiamond[0] + '/' + this.defaultdiamond[1];
//    this.pricediamond = this.pricelist.Diamond.filter(x => x.diamond_type == this.diamond.jwellery_size);
//    this.pricediamond = this.pricediamond.find(x => x.type == name);
//    if (this.pricediamond)
//    {
//      this.totaldiamond = this.api.price(this.diamond.weight,this.pricediamond.price,this.diamond.charges_option,this.diamond.making_charge,0,0,this.diamond.quantity);
//      this.totaldiamond = this.totaldiamond.price;
//    this.total();
//    this.grossweight();
//    this.button();
//  } else  {
//      this.button();
//    }
//    } else if(type ==2){

//      let name = this.defaultdiamond2[0] + '/' + this.defaultdiamond2[1];
//      this.pricediamond2 = this.pricelist.Diamond.filter(x => x.diamond_type == this.diamond2.jwellery_size);
//      this.pricediamond2 = this.pricediamond2.find(x => x.type == name);
//      if (this.pricediamond2)
//      {
//        this.totaldiamond2 = this.api.price(this.diamond2.weight,this.pricediamond2.price,this.diamond2.charges_option,this.diamond2.making_charge,0,0,this.diamond2.quantity);
//        this.totaldiamond2 = this.totaldiamond2.price;

//      this.total();
//      this.grossweight();
//      this.button();
//    } else  {
//        this.button();
//      }
//    }
//  }

//  diamondchange(value,value2) {
//   if(value == 1) {
//     this.diamond = this.diamondlist1.find(x => x.jwellery_size == value2);
//     this.diamondcolour = this.diamond.color.split(',');
//     this.diamondclarity = this.diamond.clarity.split(',');
//     this.diamondcolour.forEach(element => {
//       this.discol.push(0);
//     });
//     this.diamondclarity.forEach(element => {
//       this.discla.push(0)
//     });
//     this.defaultdiamond = this.diamond.default_color_clarity.split('/');
//     this.diamondprice();
//   } else if(value == 2) {
//     this.diamond2 = this.diamondlist2.find(x => x.jwellery_size == value2);
//     this.diamondcolour2 = this.diamond2.color.split(',');
//     this.diamondclarity2 = this.diamond2.clarity.split(',');

//     this.diamondcolour2.forEach(element => {
//     this.discol2.push(0);
//   });
//     this.diamondclarity2.forEach(element => {
//     this.discla2.push(0);
//   });
//     this.defaultdiamond2 = this.diamond2.default_color_clarity.split('/');
//     this.diamondprice(2);
//   }
// }

  grossweight() {
    let weight = 0;
    if (this.gold && Object.keys(this.gold).length !== 0) {
      weight = weight + Number(this.gold.weight);
    }
    if (this.platinum) {
      weight = weight + Number(this.platinum.weight);
    }
    if (this.diamond) {
      weight = weight + Number(this.diamond.weight * 0.2);
    }
    if (this.stone) {
      weight = weight + Number(this.stone.weight);
    }
    if (this.silver) {
      weight = weight + Number(this.silver.weight);
    }
    if (this.gram) {
      weight = weight + Number(this.gram.weight);
    }
    if (this.kundan) {
      weight = weight + Number(this.kundan.weight);
    }
    if (this.black) {
      weight = weight + Number(this.black.weight);
    }
    if (this.ade) {
      weight = weight + Number(this.ade.weight);
    }

    this.gross = weight.toFixed(3);
  }

  // total() {
  //   let price = 0;
  //   if (this.pricegold) {
  //     price = price + this.totalgold;
  //   }
  //   if (this.priceplat) {
  //     price = price + this.totalplat;
  //   }
  //   if (this.pricediamond) {
  //     price = price + this.totaldiamond;
  //   }
  //   if (this.pricestone) {
  //     price = price + this.totalstone;
  //   }
  //   if (this.pricesilver) {
  //     price = price + this.totalsilver;
  //   }
  //   if (this.pricegram) {
  //     price = price + this.totalgram;
  //   }
  //   if (this.priceblack) {
  //     price = price + this.totalblack;
  //   }
  //   if (this.pricekund) {
  //     price = price + this.totalkundan;
  //   }
  //   console.log("###Price Diamond", this.totaldiamond)
  //   console.log("###Price", price)
  //   if(this.data){
  //   if(this.data.offer_type){
  //     if(this.data.offer_type == 'Flat'){
  //       console.log('inside flat');
  //       this.offer = Number(price) - Number(this.data.offer_amount);
  //     }else if(this.data.offer_type == 'Percentage'){
  //       console.log('inside Percentage');
  //       this.offer = Number(price)  - Number(price)*0.01*Number(this.data.offer_amount);
  //     }
  //     console.log("******Offer", this.offer);
  //     if(this.igst) {
  //       console.log('inside IGST');
  //       if(this.offer==0){
  //         this.tax = Number(price) * 0.01 * Number(this.data.IGST);
  //       } else{
  //         this.tax = Number(this.offer) * 0.01 * Number(this.data.IGST);
  //         this.offer = Number(this.offer)+Number(this.offer) * 0.01 * Number(this.data.IGST);
  //       }
  //       this.totalprice = Number(price)  + Number(this.tax);
  //     } else {
  //        console.log('Outside IGST');
  //       if(this.offer==0){
  //         this.tax = Number(price) * 0.01 * Number(this.data.SGST)+Number(price) *0.01 * Number(this.data.CGST);
  //       } else{
  //         this.tax = Number(this.offer)* 0.01 * Number(this.data.SGST)+Number(this.offer) *0.01 * Number(this.data.CGST);
          
  //         this.offer = Number(this.offer) +Number(this.offer)* 0.01 * Number(this.data.SGST)+Number(this.offer) *0.01 * Number(this.data.CGST);
  //       }
        
  //       console.log("******Tax", this.tax);
  //       this.totalprice = Number(price)  + Number(this.tax);
  //     }

  //   }else{
  //     if(this.igst) {

        
  //       if(this.offer==0){
  //         this.tax = Number(price) * 0.01 * Number(this.data.IGST);

  //       } else{
  //         this.tax = Number(this.offer) * 0.01 * Number(this.data.IGST);
  //         this.offer = Number(this.offer)+Number(this.offer) * 0.01 * Number(this.data.IGST);
  //       }
  //       this.totalprice = Number(price)+Number(price) * 0.01 * Number(this.data.IGST);

  //     } else {

        
  //       if(this.offer==0){
  //         this.tax = Number(price) * 0.01 * Number(this.data.SGST)+Number(price) *0.01 * Number(this.data.CGST);
  //       } else{
  //         this.tax = Number(this.offer)* 0.01 * Number(this.data.SGST)+Number(this.offer) *0.01 * Number(this.data.CGST);
  //         console.log(this.offer);
  //         this.offer = Number(this.offer) +Number(this.offer)* 0.01 * Number(this.data.SGST)+Number(this.offer) *0.01 * Number(this.data.CGST);
  //       }
  //       this.totalprice = Number(price)+Number(price) * 0.01 * Number(this.data.SGST)+Number(price) *0.01 * Number(this.data.CGST);

  //     }
  //   }


  // }
  // this.manualoffer();
  // }

  total() {
    let price = 0;
    if (this.pricegold) {
      price = price + this.totalgold;
    }
    if(this.totalade){
      price = price + this.totalade;
    }
    if (this.priceplat) {
      price = price + this.totalplat;
    }
    if (this.totaldiamond) {
      price = price + this.totaldiamond;
    }
    if (this.pricestone) {
      price = price + this.totalstone;
    }
    if (this.pricesilver) {
      price = price + this.totalsilver;
    }
    if (this.pricegram) {
      price = price + this.totalgram;
    }
    if (this.priceblack) {
      price = price + this.totalblack;
    }
    if (this.pricekund) {
      price = price + this.totalkundan;
    }
    this.totalAmount = price;
    if(this.data){
    if(this.data.offer_type){
      if(this.data.offer_type == 'Flat'){
        this.offer = Number(price) - Number(this.data.offer_amount);
      }else if(this.data.offer_type == 'Percentage'){
        this.offer = this.calculatePercentage(Number(price), Number(this.data.offer_amount));
      }
      if(this.igst) {
        if(this.offer==0){
          this.tax = this.calculatePercentage(Number(price), Number(this.data.IGST));
        } else{
          let discountAmount = Number(price) - Number(this.offer);
          this.tax = this.calculatePercentage(Number(discountAmount), Number(this.data.IGST));
          this.offerPrice = Number(price) + Number(this.tax) - Number(this.offer);
        }
        this.totalprice = Number(price)  + Number(this.tax);
      } else {
        if(this.offer==0){
          this.tax = this.calculatePercentage(Number(price), Number(this.data.SGST) + Number(this.data.CGST));
        } else{
          let discountAmount = Number(price) - Number(this.offer);
          this.tax = this.calculatePercentage(Number(discountAmount), Number(this.data.SGST) + Number(this.data.CGST));
          this.offerPrice = Number(price) + Number(this.tax) - Number(this.offer);
        }
        this.totalprice = Number(price)  + Number(this.tax);
      }

    }else{
      if(this.igst) {
        if(this.offer==0){
          this.tax = this.calculatePercentage(Number(price), Number(this.data.IGST));
        } else{
          let discountAmount = Number(price) - Number(this.offer);
          this.tax = this.calculatePercentage(Number(discountAmount), Number(this.data.IGST));
          this.offerPrice = Number(price) + Number(this.tax) - Number(this.offer);;
        }
        this.totalprice =  Number(price)  + Number(this.tax);
      } else {
        if(this.offer==0){
          this.tax = this.calculatePercentage(Number(price), Number(this.data.SGST) + Number(this.data.CGST));
        } else{
          let discountAmount = Number(price) - Number(this.offer);
          this.tax = this.calculatePercentage(Number(discountAmount), Number(this.data.SGST) + Number(this.data.CGST));
          this.offerPrice =  Number(price) +  Number(this.tax) - Number(this.offer);;
        }
        this.totalprice = Number(price)  + Number(this.tax);
      }
    }
  }
  this.manualoffer();
  }

  calculatePercentage(value: number, percentage: number): number {
    return Number((value * percentage) / 100) 
  }


  clean(){
    this.pid= null;
    this.data= null;
    this.assets= null;
    this.recents= null;
    this.category= null;
    this.subcategory= null;
    this.subsubcategory= null;
    this.url= null;
    this.prd_img= null;
    this.goldquality= null;
    this.gold= null;
    this.pricelist= null;
    this.pricegold= null;
    this.diamond= null;
    this.diamondclarity= null;
    this.diamondcolour= null;
    this.defaultdiamond= null;
    this.pricediamond= null;
    this.totaldiamond= null;
    this.totalade= null;
    this.totalgold= null;
    this.finegold= null;
    this.platinum= null;
    this.priceplat= null;
    this.fineplat= null;
    this.totalplat= null;
    this.defaultsize= null;
    this.sizes= null;
    this.selectedsize= null;
    this.totalprice= null;
    this.certificate= null;
    this.value = 1;
    this.wish= null;
    this.cart= null;
    this.stone= null;
    this.totalstone= null;
    this.pricestone= null;
    this.pricegold2= null;
    this.gross= null;
    this.colvalue= null;
    this.silver= null;
    this.pricesilver= null;
    this.totalsilver= null;
    this.loader= null;
    this.page= null;
    this.scroll= null;
    this.drop= this.api.drop;;
    this.loading= null;
    this.viewdone=0;
    this.metalcolour= null;
    this.goldlist= null;
    this.stonelist= null;
    this.diamondlist= null;
    this.message= null;
    this.btn = 1;
    this.kundan= null;
    this.totalkundan= null;
    this.pricekund= null;
    this.black= null;
    this.priceblack= null;
    this.totalblack= null;
    this.pricegram= null;
    this.totalgram= null;
    this.gram= null;
    this.kundanlist= null;
    this.privious= null;
    this.defsilver= null;
    this.defplat= null;
    this.blacklist= null;
    this.manufacture= null;
    this.sizelist= null;
    this.silverlist= null;
    this.adeList= null;
  }
  change(value)
  {
    this.pincode=value.target.value;
  }
  check(){
    let state:any = this.api.Getgst(this.pincode)
    setTimeout(() => {
      if(state.__zone_symbol__value.data)
      {
      state = state.__zone_symbol__value.data[0].state_name;

      }else{
        this.api.onSuccess('Available in Your area','Available');
      }
      if(state.toUpperCase() == 'MAHARASHTRA'){
       this.igst = false;
       this.api.onSuccess('Available in Your area','Available');
       this.total();
      } else if(state.toUpperCase() != 'MAHARASHTRA'){
        this.api.onSuccess('Available in Your area','Available');
        this.igst = false;
        this.total();
      }
      },1000);
  }

   onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      const files = Array.from(input.files);

      for (let file of files) {
        this.selectedFiles.push(file);

        const reader = new FileReader();
        reader.onload = () => {
          this.imagePreviews.push(reader.result as string);
        };
        reader.readAsDataURL(file);
      }
    }
  }

  removeImage(index: number) {
    this.selectedFiles.splice(index, 1);
    this.imagePreviews.splice(index, 1);
    if(this.comments?.my_comment?.images.split(",")?.length > 0){
      this.deleteUserImage(index)
    }
  }

  ngOnInit() {

    this.loader = true;
    this.page = false;
    this.api.getlogin.subscribe(data => {
      console.log(+data);
      this.drop = data;
     });
  }

}
